
export default {
  name: 'MegasredaContentRecommendationsFeedCard',
  props: {
    recommendation: {
      type: Object,
      default: null,
    },
    isTarget: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAuthor() {
      if (this.recommendation?.author?._id) {
        return this.$auth?.user?._id === this.recommendation.author._id
      } else {
        return false
      }
    },
    isClient() {
      return !!this.recommendation?.author?.isClient
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },

    preText() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          let preText = text.blocks?.filter(
            (block) => block.type === 'paragraph' || block.type === 'header'
          )
          preText = preText.slice(0, 2).map((p) => {
            return p.data.text
          })

          preText = preText.join('<br />')
          const sanitizeText = preText.replace(/&nbsp;/g, ' ').trim()
          return sanitizeText
        }
      }
      return ''
    },
    shareTitle() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        let preText = ''
        if (text?.blocks?.length) {
          const header = text.blocks?.find((block) => block.type === 'header')

          if (header) {
            preText = header.data.text
          } else {
            const firstParagraf = text.blocks?.find(
              (block) => block.type === 'paragraph'
            )

            preText = firstParagraf ? firstParagraf.data.text : ''
          }
          const sanitizeText = preText.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        }
      }
      return ''
    },
    shareDescription() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          let preText = text.blocks?.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        }
      }
      return ''
    },
  },
  methods: {
    openPreviewModal(recommendationId) {
      this.$refs.previewModal.open(recommendationId)
    },
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/recommendation', {
        username: this.recommendation.author.username,
        recommendationId: this.recommendation._id,
      })
    },
    closeMenu() {
      this.isShowStreamsPopUp = false
    },
  },
}
